import { A4uChevronRight as IconComponent } from '@adobe/react-spectrum-workflow/dist/ChevronRight.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function ChevronRight(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}